(function () {
  angular
    .module('specsguardApp')
    .factory('EditorConfig', EditorConfig);

  EditorConfig.$inject = ['Auth', '$timeout', 'sgSanitizeFilter'];

  function EditorConfig(Auth, $timeout, sgSanitize) {
    function getLanguageCode(lang) {
      const languages = {
        nl: 'nl',
        'nl-NL': 'nl',
        en: 'en',
        'en-US': 'en',
        'en-UK': 'en'
      };

      return languages[lang] || false;
    }

    function getLanguageUrl(code) {
      return code.includes('en') ? false : `/assets/languages/${code}.js`;
    }

    const sgElementOptionPrefix = 'sg-element-option-';

    // returns a string used in editorconfig to determine which menuItems should be placed under sg (if any)
    function getSgMenuItemsString({element}) {
      let string = '';
      const {options} = element;
      if (options) {
        element.options.forEach((option, i) => {
          string += `${sgElementOptionPrefix}${i} `;
        });
      }

      return string + '| ';
    }

    function addSgElementMenuItems(element: any = {}, editor) {
      const {options} = element;

      if (!options || options.length === 0) {
        return;
      }

      options.forEach((option, i) => {
        editor.addMenuItem(sgElementOptionPrefix + i, {
          context: 'sg',
          text: option.prefix,
          menu: [{
            context: 'sg',
            // Only way I found how to actually set raw html
            onPostRender: function addSgInnerHtml(ctrl) {
              ctrl.control.innerHtml(sgSanitize(option.value));
            },
            onClick: function () {
              editor.setContent(sgSanitize(option.value));
              editor.isDirty(true);
              editor.focus();
            }
          }]
        });
      });
    }

    return function ConfigCreator({contentLanguage, inline = false, readonly = false, focus = false, element = {}}) {
      return ({
        inline,
        readonly,
        body_class: 'sg-inline-edit-input',
        menubar: 'sg edit insert view format table tools help',
        menu: {
          // sg holds our custom menu items that allow to set template element values
          // all other menu items are standard
          sg: {title: 'Specsguard', items: getSgMenuItemsString({element})},
          edit: {title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall'},
          insert: {title: 'Insert', items: 'link inserttable | charmap | insertdatetime'},
          view: {title: 'View', items: 'code | visualaid visualblocks | spellchecker'},
          format: {
            title: 'Format', items: 'bold italic underline strikethrough superscript subscript |' +
              ' blockformats | align | removeformat'
          },
          table: {title: 'Table', items: 'inserttable tableprops deletetable | cell row column'},
          tools: {title: 'Tools', items: 'spellchecker spellcheckerlanguage code'}
        },
        removed_menuitems: 'codeformat',
        statusbar: false,
        toolbar: `undo redo |
                forecolor backcolor bold italic underline | 
                alignleft aligncenter alignright alignjustify| 
                indent outdent | 
                bullist numlist | 
                table | 
                link`,
        plugins: ['advlist lists charmap help autoresize noneditable',
          'visualblocks textcolor advcode link mediaembed',
          'insertdatetime table powerpaste tinymcespellchecker a11ychecker',
          'contextmenu'],
        block_formats: 'Paragraph=p',
        invalid_styles: 'font-size font-family',
        invalid_elements: 'h1,h2,h3,h4,h5,h6,pre',
        branding: false,
        autoresize_bottom_margin: 50,
        autoresize_max_height: 300,
        default_link_target: '_blank',
        target_list: [
          {title: 'New page', value: '_blank'},
        ],
        link_assume_external_targets: true,
        elementpath: false,
        /**
         * PowerPaste gotcha's:
         * - Due to limitations in Excel online PowerPaste does not support pasting from Excel online.
         * If you paste content using Excel in Office Live you will get a plain text representation of the content.
         *
         * - PowerPaste will import images from pasted Microsoft Word/Excel content.
         * When doing this, PowerPaste extracts Base64 encoded images from the clipboard.
         * Images larger than approximately 8.5MB may fail to import based on technical limitations of web browsers.
         *
         * - When using the Windows operating system, copying and pasting content from Word 2013 (or later)
         * in "Protected View" will result in plain, unformatted text.
         * This is due to how Protected View interacts with the clipboard
         *
         * */
        powerpaste_word_import: 'merge',
        powerpaste_allow_local_images: true,
        // angular-ui-tinymce does not include themes so we have to use the cdn
        // Disabled theme, links is broken, even after updating to new Url:
        // baseURL: 'https://cdn.tiny.cloud/1/dpnl0z61t3gfwmqvfzj5ve50a737cps3kcf27di8enqhm61i/tinymce/4.7.13/',
        // TODO check if needed, I assume it is otherwise chars like € will be converted to &1652t; in pdf
        entity_encoding: 'raw',
        language_url: getLanguageUrl(getLanguageCode(Auth.getCurrentUser().userLanguage)),
        spellchecker_languages: 'English=en,Dutch=nl',
        spellchecker_language: getLanguageCode(contentLanguage),
        custom_undo_redo_levels: 10,
        setup: (editor) => {

          editor.on('init', function () {
            if (editor.settings.onInit) {
              $timeout(function () {
                editor.settings.onInit(editor);
              });
            }
          });

          if (focus) {
            $timeout(function () {
              editor.focus();
            });
          }

          addSgElementMenuItems(element, editor);

          editor.on('keydown', (event) => {
            if (event.keyCode === 9) { // tab pressed
              if (event.shiftKey) {
                editor.execCommand('Outdent');
              } else {
                editor.execCommand('Indent');
              }

              event.preventDefault();
            }
          });
        },
      });
    };
  }
})();
